module.exports = __webpack_public_path__ + "img/portugal-stomach-cancer-male.6a77494c.png";